import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, LandmarkIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PanelCard } from './PanelCard';
interface SinglePlanOfferProps {
  className?: string;
}
const inclusions = ['Página web profesional a medida', 'Carta digital clara y fácil de consultar', 'Diseño responsive para cada pantalla', 'Gestión y mantenimiento integral', 'Actualizaciones y soporte continuo', 'Sin cuotas ni costes ocultos'];
export function SinglePlanOffer({
  className = ''
}: SinglePlanOfferProps) {
  return <section className={`section-shell border-t border-white/10 bg-[#0a0a0a] ${className}`} aria-labelledby="offer-title" data-id="element-152" data-mp="1aw9t66pd5zja">
      <div className="container mx-auto px-6 md:px-12" data-id="element-153" data-mp="16slmdq8k37z3">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-5xl" data-id="element-154" data-mp="2madwi3hud010">
          <PanelCard title="La base digital de tu negocio, en una sola propuesta." meta="La oferta" titleId="offer-title" data-id="element-155" data-mp="1yam2q9p5t92h">
            <div className="grid lg:grid-cols-[1.15fr_0.85fr]" data-id="element-156" data-mp="16jy69ayfkrv5">
              <div className="px-6 py-8 sm:px-9 sm:py-10" data-id="element-157" data-mp="16lj0ezgu28sh">
                <p className="max-w-xl text-[15px] leading-relaxed text-neutral-600" data-id="element-158" data-mp="1aki5ck2ke5jx">
                  Todo lo necesario para poner orden, elevar la percepción de tu
                  marca y facilitar que las personas adecuadas den el siguiente
                  paso.
                </p>
                <ul className="mt-7 grid gap-x-8 gap-y-3.5 border-t border-black/15 pt-6 sm:grid-cols-2" data-id="element-159" data-mp="mw8j5h1fvfs9">
                  {inclusions.map(inclusion => <li key={inclusion} className="flex gap-3 text-[13px] leading-relaxed text-neutral-700" data-id="element-160" data-mp="rsfhoori9p06">
                      <CheckIcon size={15} className="mt-0.5 shrink-0 text-black" aria-hidden="true" data-id="element-161" data-mp="1q6369g1bdtbs" />
                      {inclusion}
                    </li>)}
                </ul>
              </div>
              <div className="flex flex-col justify-between border-t-2 border-black/15 px-6 py-8 sm:px-9 sm:py-10 lg:border-l-2 lg:border-t-0" data-id="element-162" data-mp="1c8xtkx73hw7k">
                <div data-id="element-163" data-mp="1l81fsa1k6rqa">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500" data-id="element-164" data-mp="1l8b5rxmlsyvz">
                    Pago único
                  </p>
                  <p className="mt-4 text-6xl font-medium tracking-[-0.07em] text-black" data-id="element-165" data-mp="2wmos2y1pl69w">
                    350€
                  </p>
                  <p className="mt-4 text-[13px] leading-relaxed text-neutral-600" data-id="element-166" data-mp="2rmk9n2h8q1h1">
                    Importe total por adelantado. El proyecto comienza al
                    confirmar el pago.
                  </p>
                </div>
                <div className="mt-9" data-id="element-167" data-mp="3443frar4d8tt">
                  <p className="flex items-center gap-2 text-[12px] text-neutral-600" data-id="element-168" data-mp="2q6ydzmyfuw4d">
                    <LandmarkIcon size={14} aria-hidden="true" data-id="element-169" data-mp="2v59nfwktn4m2" /> Tarjeta, Apple
                    Pay o Google Pay
                  </p>
                  <Link to="/checkout" className="group mt-5 flex w-full items-center justify-center gap-2 bg-black px-5 py-4 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-170" data-mp="3iwey7xbwn6pi">
                    Continuar al pago
                    <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-171" data-mp="5mhaqz8b5n7d" />
                  </Link>
                </div>
              </div>
            </div>
          </PanelCard>
        </motion.div>
      </div>
    </section>;
}